import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface IContractAgreementDetailTextProps {}

const ContractAgreementDetailText = ({}: IContractAgreementDetailTextProps) => {
  const { itemName, setItemAndDetailValue, displayMode } =
    useFormikContractHelpers();
  const { t } = useTranslation();

  const onDefaultValueChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setItemAndDetailValue<string>(
      `content.textAgreementTemplate.defaultValue`,
      event.target.value
    );
  };

  return (
    <Contract.SideMenu.AgreementDetail.Wrapper
      name={`${itemName}.content.textAgreementTemplate.title`}
      label={t('input.label.title')}>
      <FormInput.Field
        name={`${itemName}.content.textAgreementTemplate.defaultValue`}
        label={t('input.placeholder.agreement-text')}
        onChange={onDefaultValueChange}
        displayMode={displayMode}
      />
    </Contract.SideMenu.AgreementDetail.Wrapper>
  );
};

export default ContractAgreementDetailText;
